var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.406 0H138.594C62.1719 0 0 62.1719 0 138.594V373.41C0 449.828 62.1719 512 138.594 512H373.41C449.828 512 512 449.828 512 373.41V138.594C512 62.1719 449.828 0 373.406 0V0ZM256 395.996C178.805 395.996 116.004 333.195 116.004 256C116.004 178.805 178.805 116.004 256 116.004C333.195 116.004 395.996 178.805 395.996 256C395.996 333.195 333.195 395.996 256 395.996V395.996ZM399.344 149.02C376.531 149.02 357.977 130.465 357.977 107.652C357.977 84.8398 376.531 66.2812 399.344 66.2812C422.156 66.2812 440.715 84.8398 440.715 107.652C440.715 130.465 422.156 149.02 399.344 149.02Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 146.02C195.359 146.02 146.02 195.355 146.02 256C146.02 316.641 195.359 365.98 256 365.98C316.645 365.98 365.98 316.641 365.98 256C365.98 195.355 316.645 146.02 256 146.02V146.02Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.344 96.3008C393.086 96.3008 387.992 101.395 387.992 107.652C387.992 113.91 393.086 119.004 399.344 119.004C405.605 119.004 410.699 113.914 410.699 107.652C410.699 101.391 405.605 96.3008 399.344 96.3008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7598a6a71058bef907e45c7c8c76afe0.svg";
export { ForwardRef as ReactComponent };